import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { GoogleMapsModule } from '@angular/google-maps';
import { FormsModule } from '@angular/forms';
import { CommonUtilityServiceService } from '../services/common-utility-service.service';
import { GoogleMapsLoaderService } from '../services/google-maps-loader.service';
import { ModalComponent } from '../shared/modal/modal.component';

@Component({
  selector: 'mapmodal-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, GoogleMapsModule, ModalComponent],
  templateUrl: './mapmodal-dialog.component.html',
  styleUrl: './mapmodal-dialog.component.scss',
})
export class MapmodalDialogComponent implements OnDestroy {
  private mapsLoadedSub: Subscription;

  @Input() active: boolean = false;
  @Input() siteType: any = '';
  @Input() siteId: string = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };
  @Input() data: any = {};

  @Output() modalClosed = new EventEmitter<boolean>();

  // google map
  center: google.maps.LatLngLiteral = { lat: 39.8283, lng: -98.5795 };
  zoom: number = 4;
  mapOptions: google.maps.MapOptions = {};
  polygonPaths: google.maps.LatLngLiteral[] = [];
  polygonOptions: google.maps.PolygonOptions = {
    fillColor: '#6296ff',
    fillOpacity: 0.25,
    strokeColor: '#537ed5',
    strokeOpacity: 1,
    strokeWeight: 3,
    clickable: false,
    editable: false,
    draggable: false,
  };
  mapsLoaded: boolean = false;

  // Optional starting address the vendor types for the "Get Directions" link.
  startAddress: string = '';

  constructor(
    private utilityService: CommonUtilityServiceService,
    private mapsLoader: GoogleMapsLoaderService
  ) {
    this.mapsLoadedSub = this.mapsLoader.loaded$.subscribe((loaded) => {
      this.mapsLoaded = loaded;
      if (loaded && this.data?.site) {
        this.initMap();
      }
    });
  }

  ngOnInit(): void {
    if (this.mapsLoaded && this.data?.site) {
      this.initMap();
    }
  }

  private initMap(): void {
    this.mapOptions = {
      mapTypeId: google.maps.MapTypeId.HYBRID,
      mapTypeControl: false,
    };
    this.center = this.utilityService.determineMapCenter(
      this.data.site.parcels
    );
    this.zoom = this.utilityService.determineMapZoomLevel(
      this.data.site.totalAcreage
    );
    this.polygonPaths = this.utilityService.detemineMapBounderies(this.data);
  }

  ngOnDestroy(): void {
    this.mapsLoadedSub.unsubscribe();
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }
  submit() {
    this.closeDialog();
  }

  // Google Maps deep-links, opened in a new browser tab. Prefer the site's
  // address for the query; fall back to the computed parcel center when the
  // address is blank.
  private get mapQuery(): string {
    const parts = [this.address?.streetAddress, this.address?.cityStateZip].filter(
      (part) => !!part
    );
    return parts.length ? parts.join(', ') : `${this.center.lat},${this.center.lng}`;
  }

  openInMaps(): void {
    const url =
      'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent(this.mapQuery);
    window.open(url, '_blank', 'noopener');
  }

  getDirections(): void {
    const params = new URLSearchParams({ api: '1', destination: this.mapQuery });
    const origin = this.startAddress?.trim();
    if (origin) {
      params.set('origin', origin);
    }
    window.open(
      'https://www.google.com/maps/dir/?' + params.toString(),
      '_blank',
      'noopener'
    );
  }
}
